/**
 * Kriptonio Private API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: private
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SubscriptionPlanType = 'Free' | 'Personal' | 'Starter' | 'Growth' | 'Custom';

export const SubscriptionPlanType = {
    Free: 'Free' as SubscriptionPlanType,
    Personal: 'Personal' as SubscriptionPlanType,
    Starter: 'Starter' as SubscriptionPlanType,
    Growth: 'Growth' as SubscriptionPlanType,
    Custom: 'Custom' as SubscriptionPlanType
};

